export const PolicySection = ({ id, title, paragraphs = [], bullets = [], children }) => (
  <section className="policy-section" id={id} data-testid={`policy-section-${id}`}>
    <h2 data-testid={`policy-heading-${id}`}>{title}</h2>
    {paragraphs.map((paragraph, index) => <p key={paragraph} data-testid={`policy-${id}-paragraph-${index + 1}`}>{paragraph}</p>)}
    {bullets.length ? <ul data-testid={`policy-${id}-list`}>{bullets.map((bullet, index) => <li key={bullet} data-testid={`policy-${id}-item-${index + 1}`}>{bullet}</li>)}</ul> : null}
    {children}
  </section>
);